
import { ReactComponent as DE } from '../resources/images/flags/DE.svg';
import { ReactComponent as AU } from '../resources/images/flags/AU.svg';
import { ReactComponent as BR } from '../resources/images/flags/BR.svg';
import { ReactComponent as CA } from '../resources/images/flags/CA.svg';
import { ReactComponent as ES } from '../resources/images/flags/ES.svg';
import { ReactComponent as FR } from '../resources/images/flags/FR.svg';
import { ReactComponent as IE } from '../resources/images/flags/IE.svg';
import { ReactComponent as IT } from '../resources/images/flags/IT.svg';
import { ReactComponent as MX } from '../resources/images/flags/MX.svg';
import { ReactComponent as SE } from '../resources/images/flags/SE.svg';
import { ReactComponent as UK } from '../resources/images/flags/UK.svg';
import { ReactComponent as US } from '../resources/images/flags/US.svg';
import { ReactComponent as XL } from '../resources/images/flags/earth.svg';
import { ReactComponent as IN } from '../resources/images/flags/IN.svg';
import { ReactComponent as NZ } from '../resources/images/flags/NZ.svg';
import { ReactComponent as CN } from '../resources/images/flags/CN.svg';
import { ReactComponent as CZ } from '../resources/images/flags/CZ.svg';
import { ReactComponent as JP } from '../resources/images/flags/JP.svg';
import { ReactComponent as KR } from '../resources/images/flags/KR.svg';
import { ReactComponent as NO } from '../resources/images/flags/NO.svg';
import { ReactComponent as PL } from '../resources/images/flags/PL.svg';
import { ReactComponent as PT } from '../resources/images/flags/PT.svg';
import { ReactComponent as SA } from '../resources/images/flags/SA.svg';
import { ReactComponent as SV } from '../resources/images/flags/SV.svg';
import { ReactComponent as EARTH } from '../resources/images/flags/earth.svg';
import { ReactComponent as CL } from '../resources/images/flags/CL.svg';
import { ReactComponent as CO } from '../resources/images/flags/CO.svg';
import { ReactComponent as PE } from '../resources/images/flags/PE.svg';
import { ReactComponent as AR } from '../resources/images/flags/AR.svg';

export const FlagsMap = {
  AR,
  DE,
  FR,
  AU,
  BR,
  CA,
  ES,
  IE,
  IT,
  MX,
  SE,
  UK,
  US,
  XL,
  IN,
  NZ,
  CN,
  CZ,
  JP,
  KR,
  NO,
  PL,
  PT,
  SA,
  SV,
  EARTH,
  CL,
  CO,
  PE,
};